export default "__VITE_ASSET__VnzbIF8D__"